import { useDispatch } from "react-redux";
import { ModalContainer, ModalContent, Close } from "./modalstyles";
import { toggleModal } from "../../../redux/actions";
import { useTheme } from "styled-components";

const CustomModal = ({ width = "60%", children }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  return (
    <ModalContainer>
      {/* Modal content */}
      <ModalContent
        style={{
          backgroundColor: theme.white,
          width: width,
          borderRadius: "3%",
        }}
      >
        <Close className="close" onClick={() => dispatch(toggleModal(0))}>
          ×
        </Close>
        {children}
      </ModalContent>
    </ModalContainer>
  );
};
export default CustomModal;
